export const roleName = 'CS_MODE';
